<template>
    <div class="lw-course-contents-chapter mb-6rem" @click="sectionClicked" :class="sectionWrapperClass">
        <div class="with-flexible-parts justify-content-space-between mb-2_5rem align-items-center">
            <h3 class="learnworlds-heading3 learnworlds-heading3-large learnworlds-element lw-course-contents-chapter-name no-margin-bottom">{{sectionTitle}}</h3>
            <div v-if="displayAccessLabel && sectionAccess !== 'premium'" class="lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element learnworlds-main-text-tiny">{{sectionDisplayedAccessLabel}}</div>

            <!-- drip feed -->
            <div class="ml-20px with-flexible-parts align-items-center" v-if="dripFeedTagsDisplay">
                <span class="mr-10px small learnworlds-icon no-margin-bottom fas fa-lock"></span>
                <div class="lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element learnworlds-main-text-tiny">{{sectionDripDateLabel}}</div>
            </div>
            <!----->

        </div>

        <div v-if="sectionDescription" class="mt-2rem learnworlds-main-text-large">{{ sectionDescription }}</div>

        <div class="lw-course-contents-units mt-2rem">
            <div class="lw-course-contents-unit with-flexible-parts p-5px-0 align-items-center lw-bb-1px-fadeout90 mb-10px" v-for="unit,index in sectionUnits" @click="unitClicked(unit,...arguments)">

                <span class="mr-10px no-margin-bottom learnworlds-main-text-very-small learnworlds-icon fas fa-check" v-if="unitCompleted(unit)"></span>

                <unit-icon class="lw-contents-svg small" :icon="unit.icon"></unit-icon>

                <div class="ml-10px no-margin-bottom learnworlds-main-text learnworlds-main-text-small learnworlds-element">
                    {{unit.title}}
                </div>
                <div class="hide-sp ml-10px no-margin-bottom lw-text-color-fadeout50 learnworlds-main-text learnworlds-main-text-small learnworlds-element" v-if="getFullUnitData(unit) && getUnitExtraInfo(unit)">
                    {{getUnitExtraInfo(unit)}}
                </div>
                <span class="ml-10px no-margin-bottom learnworlds-main-text-small learnworlds-icon fas fa-paperclip" v-if="unit.attachments && unit.attachments.length"></span>
            </div>
        </div>
    </div>
</template>

<script>
    import CourseContentsTemplateMixin from "../../mixins/CourseContentsTemplateMixin";
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "CourseContentsTemplate13",
        mixins: [CourseContentsTemplateMixin,ComponentTemplatesMixin]
    }
</script>

